import L from "leaflet";

/** Tolerancia por defecto de Leaflet, en píxeles (`Draggable.options`). */
const TOLERANCIA_LEAFLET = 3;

/** Sube la tolerancia con la que Leaflet distingue un CLICK de un ARRASTRE en
 *  el paneo del mapa.
 *
 *  **El problema.** Dibujar un polígono es una seguidilla de clicks, y cada uno
 *  se hace con la mano apoyada: casi siempre hay dos o tres píxeles de
 *  movimiento entre apretar y soltar. Si Leaflet lo toma como arrastre, panea
 *  el mapa y **no dispara el click**: el vértice no se pone. Medido en el paso
 *  3, se perdían del orden de 2 de cada 10 clicks.
 *
 *  **Por qué el default rinde menos de lo que parece.** La condición de
 *  `L.Draggable._onMove` es
 *
 *      Math.abs(offset.x) + Math.abs(offset.y) < clickTolerance
 *
 *  o sea distancia **Manhattan**, no un radio. Con el default de 3, un
 *  movimiento diagonal de 2 px en cada eje ya suma 4 y arranca el arrastre: la
 *  tolerancia efectiva en diagonal es de apenas 1 px por eje.
 *
 *  **Qué NO hace.** No toca `L.Draggable.prototype`: eso lo cambiaría para
 *  todos los mapas de la app. Se escribe sobre la instancia del mapa que se le
 *  pasa, y nada más.
 *
 *  @param map El mapa. Su `dragging` tiene que estar habilitado (default de
 *   Leaflet); si estuviera apagado, `_draggable` todavía no existe y la función
 *   no hace nada.
 *  @param px Tolerancia nueva, en píxeles Manhattan. Por debajo del default de
 *   Leaflet no tiene sentido, así que se ignora.
 */
export function fx_tolerarClickAlArrastrar(map: L.Map, px: number): void {
  if (px <= TOLERANCIA_LEAFLET) return;

  // `_draggable` es interno de Leaflet: no está en los tipos. El acceso va
  // acotado acá y con guarda, para que un cambio de Leaflet no rompa el mapa
  // sino que simplemente deje la tolerancia por defecto.
  const dragging = map.dragging as unknown as {
    _draggable?: { options?: { clickTolerance?: number } };
  };
  const draggable = dragging?._draggable;
  if (!draggable?.options) return;

  draggable.options.clickTolerance = px;
}
